import { Button, InlineNotification, Tooltip } from 'carbon-components-react';
import React from 'react';
import { segmentsTracking } from 'src/common/lib/tracker';
import PublicImage from 'src/common/components/PublicImage';
import { ArrowRight20 } from '@carbon/icons-react';
import './Step.scss';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import {
  checkForEComm,
  WindowOpenFunction,
} from 'src/common/hooks/widgets/useLang';

type ResponseStepExtendedProps = {
  pathSelected: string;
  picture: string;
  title: string;
  linkUrl?: string;
  iconPath1: string;
  iconPath2: string;
  linkText: string;
  edition: string;
  purchaseText: string;
  checkbox: boolean;
  setDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  handleUrxForm: () => void;
  setEmailBtnState: React.Dispatch<React.SetStateAction<boolean>>;
  title2?: string;
  useTranslation: TranslationFunction;
  windowOpen: WindowOpenFunction;
  spss_offer_text?: string;
  spss_offer_action?: string;
  offerApplied: boolean;
  ecomm: string | undefined;
};

const ResponseStepExtended = ({
  pathSelected,
  picture,
  title,
  linkUrl,
  linkText,
  iconPath1,
  iconPath2,
  edition,
  purchaseText,
  checkbox,
  handleUrxForm,
  title2,
  useTranslation,
  windowOpen,
  spss_offer_text,
  spss_offer_action,
  offerApplied,
  ecomm,
}: ResponseStepExtendedProps) => {
  const handleEmail = () => {
    handleUrxForm();
  };

  return (
    <div className="bx--grid bx--grid--condensed">
      <div className="bx--row">
        <div className="bx--row">
          <div className="bx--col-lg-9 bx--col-md-5 bx--col-sm-4 disp-flex">
            <div
              className={`padding_q8 ${
                !checkbox ? 'bg-color-base' : 'background-col-baseaddon'
              }`}
            >
              <div className="mar-pad">
                <PublicImage
                  style={{
                    backgroundColor: !checkbox ? '#E8DAFF' : '#FFD7D9',
                  }}
                  imgPath={iconPath1}
                  widgetId="spss-purchase-advisor-self-assessment"
                  id="img2"
                  alt="SPSS Self Assessment Steps picture"
                />
                <PublicImage
                  style={{
                    backgroundColor: !checkbox ? '#E8DAFF' : '#FFD7D9',
                    marginLeft: '20px',
                  }}
                  imgPath={iconPath2}
                  widgetId="spss-purchase-advisor-self-assessment"
                  id="img2"
                  alt="SPSS Self Assessment Steps picture"
                />

                <div className="page_body">
                  {title} <strong>{edition}</strong>
                </div>
                <div className="page_body spss-mar2 spss-mar3">{title2}</div>
                {checkbox ? (
                  <Tooltip
                    className="spss_tooltip tooltip-mt3"
                    onChange={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                        object: 'SPSS Purchasing Advisor Self Assessment page',
                        resultValue: 'CTA clicked',
                        CTA: 'Authorized User license tooltip',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                    direction={'top'}
                    tabIndex={0}
                    triggerText={
                      <span className="slide_text">
                        {useTranslation('note_checkbox_text')}
                      </span>
                    }
                  >
                    <span className="slide_text">
                      {useTranslation('landing_tooltip2_info1')}
                    </span>
                  </Tooltip>
                ) : (
                  <div>
                    <Tooltip
                      className="spss_tooltip tooltip-mt4"
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'Authorized User tooltip',
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                      }}
                      direction={'top'}
                      tabIndex={0}
                      triggerText={
                        <div className="slide_text spss-mar2">
                          {useTranslation('note_radio_text')}
                        </div>
                      }
                    >
                      <span className="slide_text">
                        {useTranslation('landing_tooltip2_info1')}
                      </span>
                    </Tooltip>
                    <Tooltip
                      className="spss_tooltip tooltip-mt5"
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'Concurrent User tooltip',
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                      }}
                      direction={'top'}
                      tabIndex={0}
                      triggerText={
                        <span className="slide_text">
                          {useTranslation('note2_radio_text')}
                        </span>
                      }
                    >
                      <span className="slide_text">
                        {useTranslation('landing_tooltip2_info2')}
                      </span>
                    </Tooltip>
                  </div>
                )}
                <div className="page_body_2 spss-mar2">{purchaseText}</div>
                {checkbox ? (
                  checkForEComm(ecomm, 'NA') ? (
                    <Button
                      renderIcon={ArrowRight20}
                      kind="primary"
                      className="cta-button-response"
                      onClick={() => {
                        handleEmail();
                      }}
                    >
                      {linkText}
                    </Button>
                  ) : (
                    <Button
                      renderIcon={ArrowRight20}
                      kind="primary"
                      className="cta-button-response"
                      onClick={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: `${linkText} - ${pathSelected}`,
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                        setTimeout(async () => {
                          windowOpen
                            ? windowOpen(linkUrl, '_blank')
                            : window.open(linkUrl, '_blank');
                        }, 250);
                      }}
                    >
                      {linkText}
                    </Button>
                  )
                ) : (
                  <Button
                    renderIcon={ArrowRight20}
                    kind="primary"
                    className="cta-button-response"
                    onClick={() => {
                      handleEmail();
                    }}
                  >
                    {linkText}
                  </Button>
                )}
              </div>
              <div>
                {checkbox && offerApplied ? (
                  <div className="color_blue">
                    <InlineNotification
                      kind="info"
                      role="onEDREnterprise"
                      title={spss_offer_text || 'Offer'}
                      subtitle={spss_offer_action}
                      hideCloseButton={true}
                    />
                    <Button
                      className="cta-button"
                      kind="primary"
                      onClick={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: `${linkText} - ${pathSelected}`,
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                        setTimeout(async () => {
                          windowOpen
                            ? windowOpen(linkUrl, '_blank')
                            : window.open(linkUrl, '_blank');
                        }, 250);
                      }}
                    >
                      {linkText}
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="bx--col-lg-7 bx--col-md-3 bx--col-sm-4 disp-flex">
            <PublicImage
              imgPath={picture}
              widgetId="spss-purchase-advisor-self-assessment"
              id="img3"
              alt="SPSS Self Assessment Steps picture"
              style={{ backgroundColor: checkbox ? '#F3F3F3' : '' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponseStepExtended;
